module.exports = __webpack_public_path__ + "static/media/lens3.1f19d050.png";